// extracted by mini-css-extract-plugin
module.exports = {"readReceipts":"widget-space--readReceipts--1eyI0"};